/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  faExclamation,
  faMicrophone,
  faPause,
  faPlay,
  faStop,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RECORDING_STATUS } from '../../../constants/constants';
import Button from '../../../common/components/button/button.component';
import Timer from './timer/timer.component';
import RecorderPlayer from './recorder-player/recorder-player.component';
import ProgressBar from '../../../common/components/progress-bar/progress-bar.component';
import commonStore from '../../../common/stores/common.store';
import './recorder-content.style.css';

/**
 * Class representing the recorder content component.
 * @extends Component
 * */
class RecorderContent extends Component {

  static propTypes = {
    clearTimer: PropTypes.func.isRequired,
    parseTimer: PropTypes.string.isRequired,
    pauseAudio: PropTypes.func.isRequired,
    playAudio: PropTypes.func.isRequired,
    recordBlob: PropTypes.shape({}),
    resetAudio: PropTypes.func.isRequired,
    setAudio: PropTypes.func.isRequired,
    setStatus: PropTypes.func.isRequired,
    startTimer: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    updateProgress: PropTypes.func.isRequired,
    width: PropTypes.string.isRequired,
  };

  static defaultProps = {
    recordBlob: null
  };

  /**
   * Starts the recording.
   * */
  onStartRecording = () => {
    const { startTimer } = this.props;
    commonStore.showSpinner();
    startTimer();
  };

  /**
   * Stops the recording.
   * */
  onStopRecording = () => {
    const { clearTimer } = this.props;

    clearTimer();
  };

  /**
   * Plays the recording.
   * */
  onRecordingPlay = () => {
    const { playAudio } = this.props;

    playAudio();
  };

  /**
   * Pause the recording.
   * */
  onRecordingPause = () => {
    const { pauseAudio } = this.props;

    pauseAudio();
  };

  render() {
    const {
      parseTimer,
      recordBlob,
      resetAudio,
      setAudio,
      setStatus,
      status,
      updateProgress,
      width,
    } = this.props;

    return (
      <div className="recorder-content">
        {status === RECORDING_STATUS.WAITING && (
          <Button
            buttonClass="btn btn-link btn-main btn-record"
            fontAwesomeIcon={faMicrophone}
            fontAwesomeSize="2x"
            onButtonClick={this.onStartRecording}
          />
        )}
        {status === RECORDING_STATUS.RECORDING && (
          <Button
            buttonClass="btn btn-link btn-main btn-stop"
            fontAwesomeIcon={faStop}
            fontAwesomeSize="lg"
            onButtonClick={this.onStopRecording}
          />
        )}
        {status === RECORDING_STATUS.RECORDED && (
          <Button
            buttonClass="btn btn-link btn-main btn-record"
            fontAwesomeIcon={faPlay}
            fontAwesomeSize="lg"
            onButtonClick={this.onRecordingPlay}
          />
        )}
        {status === RECORDING_STATUS.PLAYING && (
          <Button
            buttonClass="btn btn-link btn-main btn-record"
            fontAwesomeIcon={faPause}
            fontAwesomeSize="lg"
            onButtonClick={this.onRecordingPause}
          />
        )}
        {status === RECORDING_STATUS.ERROR && (
          <div>
            <div
              className="btn btn-link btn-main btn-stop btn-error"
            >
              <FontAwesomeIcon icon={faExclamation} size="2x" />
            </div>
          </div>
        )}
        <Timer parseTimer={parseTimer} status={status} />
        <RecorderPlayer
          resetAudio={resetAudio}
          recordBlob={recordBlob}
          setAudio={setAudio}
          setStatus={setStatus}
          status={status}
          updateProgress={updateProgress}
        />
        {(status === RECORDING_STATUS.RECORDED || status === RECORDING_STATUS.PLAYING) && (
          <ProgressBar width={width} />
        )}
      </div>
    );
  }

}

export default RecorderContent;



// WEBPACK FOOTER //
// ./src/messages/recorder/recorder-content/recorder-content.component.js